<section id="content" *ngIf="lang">

  <div class="page page-profile">

    <div class="pageheader">

      <h2>{{ modalTitle }}
      </h2>

    </div>

    <!-- page content -->
    <div class="pagecontent">


      <!-- row -->
      <div class="row">

        <div class="col-md-12">

          <!-- tile -->
          <section class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body p-0">

              <div role="tabpanel">


                <!-- Tab panes -->
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">

                    <div class="wrap-reset">

                      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
                        <div *ngFor="let validation of msg">
                          <div class="error-message"
                            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
                            {{validation.message}}
                          </div>
                        </div>
                      </ng-template>

                      <form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">

                        <div class="row">

                          <div class="col-sm-12 nopaddno">
                            <div class="form-group col-sm-6">
                              <label for="first-name">{{ lang.code }}</label>
                              <input type="text" class="form-control" formControlName="code"
                                [ngClass]="formErrorClass(createForm.controls.code, createFormSubmitted)">

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                                [ngTemplateOutletContext]="{msg:createFormErrorMsg.code, value:createForm.controls.code, submitted:createFormSubmitted }">
                              </ng-template>


                            </div>


                            <div class="form-group col-sm-6">
                              <label>{{ lang.customer }}</label>
                              <select class="form-control" formControlName="customer"
                                [ngClass]="formErrorClass (createForm.controls.customer, createFormSubmitted)">
                                <option value="">{{ lang.selectCustomer }}</option>
                                <option *ngFor="let resp of contract_type" [ngValue]="resp.item_id">{{resp.item_name}}
                                </option>
                              </select>

                              <ng-template [ngTemplateOutlet]="ErrorMsg"
                                [ngTemplateOutletContext]="{msg:createFormErrorMsg.customer, value:createForm.controls.customer, submitted:createFormSubmitted }">
                              </ng-template>

                            </div>
                          </div>

                          <div  formArrayName="attachments">

                          <section  *ngFor="let link of attachments().controls; let i = index;" [formGroupName]="i">
                          <div class="well-sm wellwell-smnewset">
                            <div class="form-group col-sm-12">
       
                              <div class="form-group col-sm-6">
                                <label>{{ lang.contract_type }}</label>
                                <select class="form-control" formControlName="contract_type"
                                  [ngClass]="formErrorClass (createForm.controls.contract_type, createFormSubmitted)">
                                  <option value="">{{ lang.selectCustomer }}</option>
                                  <option *ngFor="let resp of contractType" [ngValue]="resp.value">{{resp.text }}
                                  </option>
                                </select>
                              </div>

                              <div class="form-group col-sm-6 datepicker">
                                <label>{{ lang.startingDate }}</label>
                                <input type="date" class="form-control" formControlName="starting_date"
                                  [ngClass]="formErrorClass(createForm.controls.starting_date, createFormSubmitted)">
                              </div>


                              <div class="form-group col-sm-4">
                                <label for="first-name">{{ lang.meetingsper }}</label>
                                <input type="text" class="form-control" formControlName="meeting_year"
                                  [ngClass]="formErrorClass(createForm.controls.meeting_year, createFormSubmitted)">


                              </div>

                              <div class="form-group col-sm-4">
                                <label for="first-name">{{ lang.amount }}</label>
                                <input type="text" class="form-control" formControlName="amount"
                                  [ngClass]="formErrorClass(createForm.controls.amount, createFormSubmitted)">
                              </div>                              

                              <div class="col-sm-4" >
                                <div class="form-group col-sm-12">
                                  <label>{{ lang.contract }}</label>
                                  <div class="form-group row">
                                    <div class="col-sm-10">
                                      <input type="file" class="filestyle" data-buttonText="Choose file"
                                        (change)="selectAttachment1($event,i)" appFileDesign>
                                        <input type="hidden" class="form-control"  id=consultancy-img-{{i}} formControlName="link">
                                        <a *ngIf="const_type_data && const_type_data[i]" href="http://vmi313621.contaboserver.net/Software_backend/uploads/consultancy/{{const_type_data[i].contract_file.split('/').pop()}}"
                                        target="_blank">{{const_type_data[i].contract_file.split('/').pop()}}</a>

                                    </div>
                                    <div class="col-sm-2 cons-action" style="display: inline-flex;">
                                      <button class="btn btn-primary pull-right" type="button" (click)="removeFile(i)">
                                        <i class="fa fa-trash-o"></i>
                                      </button>
                                      <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment(i)" *ngIf=" i!=(attachments().controls.length-1) ">
                                        <i class="fa fa-trash-o"></i>
                                      </button>
                                      <button class="btn btn-primary pull-right" type="button" (click)="addAttachment()" *ngIf=" i==(attachments().controls.length-1) ">
                                        <i class="fa fa-plus"></i>
                                      </button>                                      
                                    </div>

                                  </div>
                                </div>
                              </div>

         
 

       
                            </div>

                          </div>
                          </section>
                          </div>

                          <div class="form-group col-sm-2">
                            <button type="submit" class="btn btn-primary">{{ lang.submit }}</button>
                          </div>

                        </div>


                      </form>
                    

                    </div>

                  </div>



                </div>

              </div>

            </div>
            <!-- /tile body -->

          </section>
          <!-- /tile -->

        </div>


      </div>
      <!-- /page content -->

    </div>
  </div>

</section>